var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 0V3.336M11.075 20.5c-2.448-2.066-4-5.144-4-8.582 0-3.438 1.552-6.516 4-8.582m2 17.164c2.447-2.066 4-5.144 4-8.582 0-3.438-1.553-6.516-4-8.582m6.827 5.7H4.098m15.804 6.141H4.098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.da8518b64f508ee120e0bc3a8ec15d25.svg";
export { ForwardRef as ReactComponent };